import { useAuth } from '../contexts/AuthContext'

export default function Regulamento() {
  const { ligaAtual } = useAuth()
  const vidas = ligaAtual?.vidas_padrao || 3
  const semanaInicio = ligaAtual?.semana_inicio || 1
  const buyin = ligaAtual?.valor_buyin ? Number(ligaAtual.valor_buyin).toFixed(0) : null
  const comecaMeio = semanaInicio > 1
  const ultimaVida = vidas === 1 ? 'primeira' : vidas === 2 ? 'segunda' : 'terceira'

  return (
    <div style={s.wrap}>
      <div style={s.hero}>
        <div style={s.heroTitle}>📋 Regulamento</div>
        <div style={s.heroSub}>{ligaAtual?.nome} · {ligaAtual?.ano}</div>
      </div>

      <Secao numero="1" titulo="O objetivo do jogo">
        <P>O nome diz tudo: o último <strong>sobrevivente</strong> vence o campeonato. Cada participante começa com <strong>{vidas} {vidas === 1 ? 'vida' : 'vidas'}</strong>{comecaMeio ? ` — as escolhas começam apenas a partir da semana ${semanaInicio} da temporada regular` : ''} e precisa durar mais que os outros ao longo da temporada da NFL.</P>
      </Secao>

      <Secao numero="2" titulo="Como funciona cada rodada">
        <P>Em cada rodada, você escolhe um time da NFL. Há três possíveis resultados:</P>
        <ul style={s.lista}>
          <li style={s.item}><strong>✅ Vitória</strong> — seu time ganhou. Você sobrevive e mantém suas vidas.</li>
          <li style={s.item}><strong>❌ Derrota</strong> — seu time perdeu. Você perde uma vida.</li>
          <li style={s.item}><strong>🟡 Empate</strong> — apesar de raros na NFL, empates também custam uma vida. Fique atento!</li>
        </ul>
        <P>Na <strong>{ultimaVida}</strong> vez que você errar, estará eliminado.</P>
      </Secao>

      <Secao numero="3" titulo="Prazo para fazer sua escolha">
        <P>As escolhas precisam ser feitas <strong>antes do início do primeiro jogo da rodada</strong>{comecaMeio ? ` (a partir da semana ${semanaInicio})` : ''} — quase sempre às quintas-feiras às 21h15 (horário de Brasília). O prazo exato de cada semana fica visível na tela de picks.</P>
        <div style={s.alerta}>⚠️ Atenção especial para semanas atípicas: a abertura da temporada é na <strong>quarta-feira 09/09</strong>, e há semanas diferentes por causa do Thanksgiving, Natal e jogos internacionais (Austrália, Londres, Alemanha, México).</div>
        <P><strong>Se você não fizer sua escolha antes do deadline, perderá uma vida automaticamente.</strong></P>
      </Secao>

      <Secao numero="4" titulo="Restrição de times">
        {comecaMeio ? (
          <P>Você <strong>não pode repetir um time</strong> que já escolheu em rodadas anteriores <strong>dentro da sua liga</strong> — ou seja, entre as semanas {semanaInicio} e 18. Times usados em outras ligas ou antes da sua entrada não contam.</P>
        ) : (
          <P>Você <strong>não pode repetir um time</strong> que já escolheu em rodadas anteriores durante a temporada regular. Escolha com estratégia — times fortes são limitados!</P>
        )}
        <P>Se o campeonato chegar aos playoffs, todos os times são liberados novamente. Cada time pode ser escolhido <strong>uma única vez durante os playoffs</strong>, incluindo o Super Bowl.</P>
      </Secao>

      <Secao numero="5" titulo="Critérios de desempate">
        <P>Ao final da temporada, é possível ter mais de um jogador vivo. A ordem de desempate é:</P>
        <div style={s.desempate}>
          <div style={s.desempateItem}>
            <div style={s.desempateNum}>1</div>
            <div>
              <div style={s.desempateTitle}>Maior número de vidas restantes</div>
              <div style={s.desempateDesc}>Quem chegou ao fim com mais vidas fica melhor posicionado.</div>
            </div>
          </div>
          <div style={s.desempateItem}>
            <div style={s.desempateNum}>2</div>
            <div>
              <div style={s.desempateTitle}>Maior favoritismo médio <span style={s.tag}>temporada regular</span></div>
              <div style={s.desempateDesc}>Medido pelo spread médio das escolhas: quanto mais negativo, mais favorito era o time escolhido. Vence quem arriscou mais (spread médio mais alto). <strong>Congelado ao fim da semana 18.</strong></div>
            </div>
          </div>
          <div style={s.desempateItem}>
            <div style={s.desempateNum}>3</div>
            <div>
              <div style={s.desempateTitle}>Maior média de vidas</div>
              <div style={s.desempateDesc}>Soma das vidas disponíveis em cada rodada dividida pelo número de rodadas. Vence quem ficou mais tempo com mais vidas. Atualizado durante toda a temporada, incluindo playoffs.</div>
            </div>
          </div>
          <div style={s.desempateItem}>
            <div style={s.desempateNum}>4</div>
            <div>
              <div style={s.desempateTitle}>Divisão da premiação</div>
              <div style={s.desempateDesc}>Se o empate persistir após todos os critérios, a premiação é dividida igualmente entre os empatados.</div>
            </div>
          </div>
        </div>
      </Secao>

      <Secao numero="6" titulo="Buy-in e premiação">
        {buyin && (
          <P>O valor do buy-in é <strong>R$ {buyin} por participante</strong>. A premiação é distribuída conforme a colocação final:</P>
        )}
        <div style={s.premiacao}>
          {[
            { pos: '1º', pct: '65,0%', destaque: true },
            { pos: '2º', pct: '17,5%' },
            { pos: '3º', pct: '10,0%' },
            { pos: '4º', pct: '5,0%' },
            { pos: '5º', pct: '2,5%' },
            { pos: '6º (último)', pct: buyin ? `R$ ${buyin} (devolução do buy-in)` : 'Devolução do buy-in' },
          ].map(p => (
            <div key={p.pos} style={{ ...s.premiacaoItem, ...(p.destaque ? s.premiacaoDestaque : {}) }}>
              <span style={s.premiacaoPos}>{p.pos}</span>
              <span style={s.premiacaoPct}>{p.pct}</span>
            </div>
          ))}
        </div>
        <div style={{ fontSize: 11, color: '#999', marginTop: 8, lineHeight: 1.5 }}>
          * O 6º colocado recebe de volta o valor do buy-in. Os percentuais dos demais referem-se ao valor total arrecadado menos essa devolução.
        </div>
      </Secao>
    </div>
  )
}

function Secao({ numero, titulo, children }) {
  return (
    <div style={ss.secao}>
      <div style={ss.secaoHeader}>
        <span style={ss.secaoNum}>{numero}</span>
        <span style={ss.secaoTitulo}>{titulo}</span>
      </div>
      <div style={ss.secaoBody}>{children}</div>
    </div>
  )
}

function P({ children }) {
  return <p style={{ fontSize: 13, color: '#444', lineHeight: 1.65, marginBottom: 10 }}>{children}</p>
}

const s = {
  wrap: { maxWidth: 680 },
  hero: { background: 'linear-gradient(135deg, #0A2342 0%, #1a3d6b 100%)', borderRadius: 10, padding: '1.5rem', marginBottom: '1.2rem', textAlign: 'center' },
  heroTitle: { fontSize: 20, fontWeight: 700, color: 'white', marginBottom: 4 },
  heroSub: { fontSize: 13, color: 'rgba(255,255,255,0.7)' },
  lista: { paddingLeft: '1.2rem', margin: '8px 0' },
  item: { fontSize: 13, color: '#444', lineHeight: 1.65, marginBottom: 6 },
  alerta: { background: '#FAEEDA', border: '0.5px solid #BA7517', borderRadius: 8, padding: '10px 12px', fontSize: 12, color: '#633806', marginBottom: 10, marginTop: 6 },
  desempate: { display: 'flex', flexDirection: 'column', gap: 10, marginTop: 8 },
  desempateItem: { display: 'flex', gap: 12, alignItems: 'flex-start', padding: '10px 12px', background: '#f9f9f9', borderRadius: 8 },
  desempateNum: { width: 24, height: 24, borderRadius: '50%', background: '#D85A30', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, fontWeight: 700, flexShrink: 0, marginTop: 1 },
  desempateTitle: { fontSize: 13, fontWeight: 500, marginBottom: 3 },
  desempateDesc: { fontSize: 12, color: '#666', lineHeight: 1.55 },
  tag: { fontSize: 10, background: '#EAF3F8', color: '#1A5C9A', borderRadius: 99, padding: '1px 6px', fontWeight: 400, verticalAlign: 'middle', marginLeft: 4 },
  premiacao: { display: 'flex', flexDirection: 'column', gap: 4, marginTop: 8 },
  premiacaoItem: { display: 'flex', justifyContent: 'space-between', padding: '8px 12px', background: '#f9f9f9', borderRadius: 6, fontSize: 13 },
  premiacaoDestaque: { background: '#FAECE7', border: '0.5px solid #D85A30' },
  premiacaoPos: { fontWeight: 500 },
  premiacaoPct: { color: '#555' },
}

const ss = {
  secao: { background: 'white', border: '0.5px solid #eee', borderRadius: 10, marginBottom: '1rem', overflow: 'hidden' },
  secaoHeader: { display: 'flex', alignItems: 'center', gap: 10, padding: '12px 14px', background: '#f9f9f9', borderBottom: '0.5px solid #eee' },
  secaoNum: { width: 22, height: 22, borderRadius: '50%', background: '#0A2342', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, fontWeight: 700, flexShrink: 0 },
  secaoTitulo: { fontSize: 13, fontWeight: 600, color: '#0A2342' },
  secaoBody: { padding: '14px 16px' },
}
